module.exports = __webpack_public_path__ + "static/img/5(2).5263cca0.jpg";